"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dAxisLabelGenerator = void 0;
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Generates sprites for axis labels.
 */
class Cartesian2dAxisLabelGenerator {
    constructor(attachPoint, spriteProvider = new core_1.SpriteProvider(attachPoint)) {
        this.spriteProvider = spriteProvider;
    }
    getCanvas() {
        return this.spriteProvider.getCanvas();
    }
    update(entity, dpr) {
        const formattingOptions = entity.graphicsSettings.axisOptions;
        if (formattingOptions.isDirty) {
            formattingOptions.regenerate(dpr);
        }
        const connector = entity.data;
        const labelW = formattingOptions.maxWidth * dpr;
        const labelH = formattingOptions.fontSize * dpr;
        this.spriteProvider.upscaleCanvas(labelW, connector.getTraceCount() * labelH);
        const spriteLookup = Cartesian2dAxisLabelGenerator.generateSpriteLookup(entity, dpr);
        const context = this.spriteProvider.getContext();
        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.font = formattingOptions.fontString;
        // FIXME these should be part of the options
        context.textBaseline = "middle";
        context.textAlign = "center";
        const xTraceCount = connector.getXTraceCount();
        const hh = labelH * 0.5 + 0.5;
        for (let i = 0; i < xTraceCount; ++i) {
            const y = core_1.SpriteLookup.getYAtIndex(spriteLookup, i);
            context.fillText(formattingOptions.formatNumber(connector.getXTick(i)), labelW * 0.5, y + hh, labelW);
        }
        context.textAlign = "right";
        for (let i = 0, iEnd = connector.getYTraceCount(); i < iEnd; ++i) {
            const y = core_1.SpriteLookup.getYAtIndex(spriteLookup, xTraceCount + i);
            context.fillText(formattingOptions.formatNumber(connector.getYTick(i)), labelW, y + hh, labelW);
        }
        return spriteLookup;
    }
    static generateSpriteLookup(entity, dpr) {
        const labelCount = entity.data.getTraceCount();
        const formattingOptions = entity.graphicsSettings.axisOptions;
        const spriteLookup = core_1.SpriteLookup.createOne(labelCount);
        const labelH = formattingOptions.fontSize * dpr;
        const labelW = formattingOptions.maxWidth * dpr;
        for (let i = 0; i < labelCount; ++i) {
            core_1.SpriteLookup.setSpriteAtIndex(spriteLookup, i, 0, labelH * i, labelW, labelH);
        }
        return spriteLookup;
    }
}
exports.Cartesian2dAxisLabelGenerator = Cartesian2dAxisLabelGenerator;
//# sourceMappingURL=cartesian-2d-axis-label-generator.js.map